<div class="home-page">
    <div class="top-container">
        <div class="top-menu">
            <div class="header-logo"><img class="logo-img" src="./assets/svgviewer-output.svg" style="margin-left:30px" /></div>
        </div>
        <div class="header-text">
            <span class="header-text-top">
                    Designed by <br />
                    <span class="yellow-text">Orthodontists.</span>
                    <br />
                    <span class="text-with-stroke">Loved by</span>
                    <br />
                    <span class="text-with-stroke">Trendsetters.</span>
                </span>
        </div>
        <div class="lady-bg">
            <img src="./assets/Homepage_1.webp" class="top-bg" loading="lazy"/>
        </div>
    </div>
    <div class="third-circle" style="margin-top: 50px; margin-bottom: 50px;">
        <div class="outer-circle">
            <div class="inner-circle" style="background-image: url('./assets/Crowding-2.png');">

                <div class="content1">
                    <div class="green-dot"></div>
                    <div class="content-title">Jaw Pain</div>
                    <div class="content-text">Misaligned teeth can cause strain on the jaw, leading to pain and
                        discomfort.</div>
                </div>
                <div class="content2">
                    <div class="green-dot"></div>
                    <div class="content-title">Speech Issues</div>
                    <div class="content-text">Malocclusion can interfere with proper pronunciation and speech clarity.
                    </div>
                </div>
                <div class="content3">
                    <div class="green-dot"></div>
                    <div class="content-title">Tooth Wear</div>
                    <div class="content-text">Crowded or misaligned teeth make cleaning difficult, increasing the risk
                        of gum disease.</div>
                </div>
                <div class="content4">
                    <div class="green-dot"></div>
                    <div class="content-title">Self Confidence</div>
                    <div class="content-text">Misaligned teeth can affect
                        self-esteem and willingness to smile.</div>
                </div>
                    
                <div class="content5">
                    <div class="green-dot"></div><div class="content-title">Chewing difficulties</div>
                    <div class="content-text">Improper bite alignment can make chewing inefficient or painful, affecting digestion and nutrition.</div>
                </div>
            </div>
        </div>
    </div>
    <div class="fourth-section" style="display: none;">
        <div class="fourth-header">
            <div class="fourth-title">
                People Who are <br />
                <span class="slaying">Slaying</span>

            </div>
            <div class="arrow-section">
                <img class="switch-arrows" style="margin-right:25px" src="./assets/left-arrow.svg" (mouseover)="prev()">
                <img class="switch-arrows" src="./assets/right-arrow.svg" (mouseover)="next()">
            </div>
        </div>
        <div class="carousel-container">
            <div class="carousel">
                <div *ngFor="let image of currentImageSet; let i = index" class="carousel-item">
                    <img [src]="image" alt="carousel image" />
                </div>
            </div>
        </div>
    </div>
    <div class="fifth-section">
        <img src="./assets/Homepage_2.webp" class="teeth-bg" loading="lazy" />
        <div class="fifth-header">
            How you get your smile?
        </div>
        <div class="fifth-info">ALIGNER SCIENCE <span style="color:black">+</span> DIGITAL PRECISION <span
                style="color:black">+</span> DENTAL EXPERTISE</div>
        <div class="fifth-content">
            Our approach combines cutting-edge aligner technology, advanced digital solutions, and expert dental care.
            By integrating these three pillars, we deliver personalized aligner solutions that ensure precise fit,
            faster results, and a confident smile.
        </div>
        <!-- <div class="test-btn">Smile Fit Test<img src="/assets/back-white.png" class="arrow-img"></div> -->
        <!-- <div class="just-start-slaying-label">Just start slaying</div> -->
        <div class="steps-container">
            <div class="step">
                <div class="blur-bg">
                    <div class="step-header">
                        <div class="step-details">
                            <div class="step-number">Step 1</div>
                            <!-- <div class="step-time">Takes 5 minutes</div> -->
                        </div>
                    </div>
                    <div class="step-content">
                        <div class="step-title">Take a Scan</div>
                        <div class="content-brief">Visit one of our clinic to check your oral health</div>
                    </div>

                </div>
            </div>

            <div class="step">
                <div class="blur-bg">
                    <div class="step-header">
                        <div class="step-details">
                            <div class="step-number">Step 2</div>
                            <!-- <div class="step-time">Takes a day</div> -->
                        </div>
                    </div>
                    <div class="step-content">
                        <div class="step-title">Get Your Plan</div>
                        <div class="content-brief">Our orthodontists give you a customised treatment plan</div>
                    </div>
                </div>
            </div>
            <div class="step">
                <div class="blur-bg">
                    <div class="step-header">
                        <div class="step-details">
                            <div class="step-number">Step 3</div>
                            <!-- <div class="step-time">Takes a day</div> -->
                        </div>
                    </div>
                    <div class="step-content">
                        <div class="step-title">Just Slay</div>
                        <div class="content-brief">Get your aligners and start wearing them for your smile
                            transformation
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="sixth-section">
        <div class="lady-bg">
            <div class="bg-container"></div>
            <img src="./assets/SIG00698.webp" style="width:100%" loading="lazy" />
        </div>
        <div class="accordion-container">
            <div class="accordion-title">Our <span class="slaying">Medical Team</span>
                Always
                At your Side,</div>
            <div class="accordion" *ngFor="let item of medicalTeamAccordion;let i=index">
                <div class="accordion-header" (click)="openAccordion(i)">
                    <span class="accordion-label">
                        <img [src]="item.accordionIcon" class="accordion-icon">
                        {{item.accordionHeader}}</span>
                    <img src="./assets/down-arrow.png" class="arrow-icon" *ngIf="activeAccordionIndex !== i">
                    <img src="./assets/up-arrow.png" class="arrow-icon" *ngIf="activeAccordionIndex == i">
                </div>
                <div class="accordion-content" *ngIf="activeAccordionIndex == i">
                    {{item.accordionContent}}
                </div>
            </div>
        </div>
    </div>
    <div class="faq-header">
        Frequently Asked Questions About Slay
    </div>
    <div class="faq-section">
        <div class="faq-items">
            <div class="faq" *ngFor="let item of faqSet;let i=index">
                <div class="faq-question" (click)="openFaq(i)">
                    {{item.question}}
                    <span class="plus-icon" *ngIf="activeFaqIndex !== i">+</span>
                    <span class="minus-icon" *ngIf="activeFaqIndex == i">-</span>

                </div>
                <div class="faq-answer" *ngIf="activeFaqIndex == i">
                    {{item.answer}}
                </div>
            </div>
        </div>
    </div>
    <div class="image-wrapper">
        <img src="./assets/Homepage_4.webp" class="teeth-bg" loading="lazy" />
    </div>
    <div class="footer-section">
        <div class="home-menu">
            <div class="menu-header">Support</div>
            <div class="menu-items">+91 95430 74333</div>
            <div class="menu-items">support&#64;justslayit.in</div>
            <div class="menu-items" style="display:flex;justify-content: space-between;">
                <a href="https://www.instagram.com/justslayit.in/" target="_blank">
                    <img src="./assets/instagram.png" class="menu-icon">
                </a>
                <a href="https://www.instagram.com/justslayit.in/" target="_blank">
                    <img src="./assets/linkedin.png" class="menu-icon">
                </a>
                <a href="https://www.instagram.com/justslayit.in/" target="_blank">
                    <img src="./assets/facebook.png" class="menu-icon"> 
                </a>
            </div>
        </div>
        <div class="home-menu" style="margin-left: 10px;">
            <div class="menu-header">Coimbatore Dental Foundation</div>
            <div class="menu-items">1250/1, Avinashi Rd, Pappanaickenpalayam, Coimbatore- 641037</div>
            <div class="menu-items">Phone: +91 97101 89525</div>
            <div class="menu-header">Dr Smile Architect Clinic</div>
            <div class="menu-items">18, 4th St Stanes Rd, KNP Puram, Odakkadu, Tiruppur- 641687</div>
            <div class="menu-items">Phone: +91 63692 11811</div>
        </div>
        <div class="home-menu">
            <div class="menu-header">Timings</div>
            <div class="menu-items">Mon - Fri, 9:00 - 20:00</div>
            <div class="menu-items">Sat, 9:00 - 18:00</div>
        </div>
    </div>
</div>